module.exports = __webpack_public_path__ + "assets/6a77d51af20f766fe8a0ccf0a67104dc.png";